import { obterValorMaisProximo } from './obterValorMaisProximo'
import { valoresKangu } from './valoresKangu'

export function verificarCaixaAgrupada({ calcKangu, qtdItens, qtdCaixas }) {
  const VOLUME_PERMITIDO = 20

  const totalKangu = totalKanguFn({ calcKangu, qtdItens, qtdCaixas })

  const agrupar = totalKangu < VOLUME_PERMITIDO && totalKangu > 0

  if (agrupar) {
    const proximaCaixa = obterValorMaisProximo(valoresKangu, totalKangu)

    if (proximaCaixa) {
      return proximaCaixa
    }
  }

  return null
}

export function totalKanguFn({ calcKangu, qtdItens, qtdCaixas }) {
  const calc = calcKangu * qtdItens * qtdCaixas

  console.log('calc', calc, {
    calcKangu,
    qtdItens,
    qtdCaixas,
  })
  return calc
}
